import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useState, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { CollapsibleContext } from './CollapsibleContext.js';
import noop from '../../utils/noop.js';
import getPreferredValue from '../../utils/getPreferredValue.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Collapsible = function Collapsible(_ref) {
  var open = _ref.open,
      defaultOpen = _ref.defaultOpen,
      onCollapsibleHeadingClick = _ref.onCollapsibleHeadingClick,
      theme = _ref.theme,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["open", "defaultOpen", "onCollapsibleHeadingClick", "theme", "children"]);

  var _useState = useState(function () {
    return defaultOpen.reduce(function (accumulator, current) {
      accumulator[current] = true;
      return accumulator;
    }, {});
  }),
      _useState2 = _slicedToArray(_useState, 2),
      openAccordions = _useState2[0],
      setOpenAccordions = _useState2[1];

  var controlledOpenAccordions = useMemo(function () {
    return open ? open.reduce(function (accumulator, current) {
      accumulator[current] = true;
      return accumulator;
    }, {}) : undefined;
  }, [open]);
  /**
   * Sets state management for Accordion with the provided id in case it's not controlled
   * and calls event handler provided by props
   *
   * @param {Object} event - The event
   * @param {string} id - The id of the CollapsibleHeading that was clicked
   */

  var handleCollapsibleHeadingClick = function handleCollapsibleHeadingClick(event, id) {
    // If no controlled accordions values are provided
    if (!open) {
      var newOpenAccordions = _objectSpread({}, openAccordions);

      if (newOpenAccordions[id]) {
        delete newOpenAccordions[id];
      } else {
        newOpenAccordions[id] = true;
      }

      setOpenAccordions(newOpenAccordions);
    }

    onCollapsibleHeadingClick(event, id);
  }; // TODO: DRY with Tabs since they do almost the same thing, maybe a reusable hook


  var contextValue = {
    openAccordions: getPreferredValue(controlledOpenAccordions, openAccordions),
    handleCollapsibleHeadingClick: handleCollapsibleHeadingClick
  };
  var containerCss = useMemo(function () {
    return merge.all([{
      color: '#333 !important'
    }, theme]);
  }, [theme]);
  return jsx(CollapsibleContext.Provider, {
    value: contextValue
  }, jsx("div", _extends({
    css: containerCss
  }, otherProps), children));
};

Collapsible.defaultProps = {
  open: undefined,
  defaultOpen: [],
  onCollapsibleHeadingClick: noop,
  theme: {},
  children: null
};

export default Collapsible;
